"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPathParser = void 0;
const index_js_1 = require("../../../entity/index.js");
const index_js_2 = require("../../../schema/actions/parsePaths/index.js");
const constants_js_1 = require("./constants.js");
class EntityPathParser extends index_js_1.EntityAction {
    constructor(entity, id = '') {
        super(entity);
        this.parse = (attributes) => {
            this[constants_js_1.$pathParser].parse(attributes);
            return this;
        };
        this[constants_js_1.$pathParser] = new index_js_2.PathParser(entity.schema, id);
    }
    setId(nextId) {
        this[constants_js_1.$pathParser].setId(nextId);
        return this;
    }
    toCommandOptions() {
        return this[constants_js_1.$pathParser].toCommandOptions();
    }
}
exports.EntityPathParser = EntityPathParser;
